import { useState, useEffect, useRef } from 'react'
import { FILE_HOST } from 'utils/helpers/apiHelper'

/**
 * Image URL'lerini CORS sorunları olmadan yönetmek için hook
 * @param imageUrl - Image URL'si
 * @returns { imageUrl: string, imageRef: React.RefObject<HTMLImageElement> }
 */
export const useImageUrl = (imageUrl: string | undefined) => {
  const [processedImageUrl, setProcessedImageUrl] = useState<string>('')
  const imageRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (imageUrl) {
      // Check if it's a base64 data URL - skip these
      if (imageUrl.startsWith('data:')) {
        setProcessedImageUrl('') // Set empty to hide base64 images
        return
      }
      
      // Check if imageUrl already contains the /files/system/ path
      const isFullPath = imageUrl.startsWith('/files/system/')
      const fetchUrl = isFullPath 
        ? `${FILE_HOST}${imageUrl}`
        : `${FILE_HOST}/files/system/${imageUrl}`
 
      fetch(fetchUrl)
        .then(response => {
          if (response.ok) {
            return response.blob()
          }
          throw new Error('Failed to fetch image')
        })
        .then(blob => {
          const url = URL.createObjectURL(blob)
 
          setProcessedImageUrl(url)
        })
        .catch(error => {
          console.error('Error fetching image:', error)
          // Fallback to direct URL if fetch fails
          setProcessedImageUrl(imageUrl)
        })
    }
    
    // Cleanup function to revoke object URL
    return () => {
      if (imageRef.current) {
        URL.revokeObjectURL(imageRef.current.src)
      }
    }
  }, [imageUrl])

  return {
    imageUrl: processedImageUrl || imageUrl || '',
    imageRef
  }
}

/**
 * Logo URL'lerini CORS sorunları olmadan yönetmek için hook (backward compatibility)
 * @param logoUrl - Logo URL'si
 * @returns { logoUrl: string, logoRef: React.RefObject<HTMLImageElement> }
 */
export const useLogoUrl = (logoUrl: string | undefined) => {
  const { imageUrl, imageRef } = useImageUrl(logoUrl)
  return {
    logoUrl: imageUrl,
    logoRef: imageRef
  }
} 